export default __webpack_public_path__ + "static/media/rating-desc.65e62cfd.png";